import { useEffect } from "react";
import { MultiLine } from "../MultiLine.jsx";
import { useFormDispatch } from "../../FormContext.jsx";
import styles from "../../showroomForm.css.js";

const DispatchingMultiLine = ({
  formData,
  setFormData,
  required,
  label,
  description,
  fieldKey,
  error,
  validate,
}) => {
  const dispatch = useFormDispatch();
  const value = formData[fieldKey];

  useEffect(() => {
    if (error) return;
    dispatch({ type: "updateField", [fieldKey]: value });
  }, [dispatch, error, fieldKey, value]);

  return (
    <div className={styles.enhancedCompContainer}>
      <MultiLine
        error={error}
        validate={validate}
        fieldKey={fieldKey}
        label={label}
        formData={formData}
        setFormData={setFormData}
        required={required}
        description={description}
      />
    </div>
  );
};

export default DispatchingMultiLine;
